import { lazy, Suspense, StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/tokens.css'
import './styles/global.css'
import { RouterProvider, useRouter } from './lib/router'
import { MarketingPages } from './screens/marketing/MarketingPages'
import { pauseGa4 } from './lib/ga4'
import { MARKETING_PAGES } from './screens/marketing/marketingData'

const WorkshopApp = lazy(() => import('./App'))
function Root() {
  const { path } = useRouter()
  const workshopHost = window.location.hostname.startsWith('app.')
  if (!workshopHost && MARKETING_PAGES[path]) return <MarketingPages />
  pauseGa4()
  return <Suspense fallback={<p>Loading…</p>}><WorkshopApp /></Suspense>
}
createRoot(document.getElementById('root')!).render(
  <StrictMode><RouterProvider><Root /></RouterProvider></StrictMode>,
)
